import script from "./App.vue?vue&type=script&setup=true&name=App&lang=js"
export * from "./App.vue?vue&type=script&setup=true&name=App&lang=js"

import "./App.vue?vue&type=style&index=0&id=246d92c4&lang=less"

const __exports__ = script;

export default __exports__